import React, { Suspense, lazy, useState } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { CartProvider } from '../context/CartContext';
import { CartModal } from '../components/cart/CartModal';
import { UserContext } from '../context/UserContext';

const LandingPage = lazy(() =>
  import('../components/landing/LandingPage').then((module) => ({ default: module.LandingPage }))
);
const PlanPage = lazy(() =>
  import('../components/plan/PlanPage').then((module) => ({ default: module.PlanPage }))
);
const VerifyEmailPage = lazy(() =>
  import('../components/register/VerifyEmailPage').then((module) => ({
    default: module.VerifyEmailPage,
  }))
);
const AccountCreatedPage = lazy(() =>
  import('../components/register/AccountCreatedPage').then((module) => ({
    default: module.AccountCreatedPage,
  }))
);
const RegisteredPurchasePage = lazy(() =>
  import('../components/register/RegisteredPurchasePage').then((module) => ({
    default: module.RegisteredPurchasePage,
  }))
);
const ValidatingPurchasePage = lazy(() =>
  import('../components/register/ValidatingPurchasePage').then((module) => ({
    default: module.ValidatingPurchasePage,
  }))
);
const PaymentErrorPage = lazy(() =>
  import('../components/register/PaymentErrorPage').then((module) => ({
    default: module.PaymentErrorPage,
  }))
);
const ProfilePage = lazy(() =>
  import('../components/profile/ProfilePage').then((module) => ({ default: module.ProfilePage }))
);
const LoginPage = lazy(() =>
  import('../components/login/LoginPage').then((module) => ({ default: module.LoginPage }))
);
const PasswordRecoveryPage = lazy(() =>
  import('../components/password-recovery/PasswordRecoveryPage').then((module) => ({
    default: module.PasswordRecoveryPage,
  }))
);
const PasswordMessageSentPage = lazy(() =>
  import('../components/password-recovery/PasswordMessageSentPage').then((module) => ({
    default: module.PasswordMessageSentPage,
  }))
);
const SuccessfulKeyChangePage = lazy(() =>
  import('../components/change-password/SuccessfulKeyChangePage').then((module) => ({
    default: module.SuccessfulKeyChangePage,
  }))
);
const ResetPasswordPage = lazy(() =>
  import('../components/reset-password/ResetPasswordPage').then((module) => ({
    default: module.ResetPasswordPage,
  }))
);
const CatalogPage = lazy(() =>
  import('../components/catalog/CatalogPage').then((module) => ({ default: module.CatalogPage }))
);
const CourseDetailPage = lazy(() =>
  import('../components/course-detail/CourseDetailPage').then((module) => ({
    default: module.CourseDetailPage,
  }))
);
const ContactUsPage = lazy(() =>
  import('../components/contact-us/ContactUsPage').then((module) => ({
    default: module.ContactUsPage,
  }))
);
const PlanAdminPage = lazy(() =>
  import('../components/admin/plans/PlanAdminPage').then((module) => ({
    default: module.PlanAdminPage,
  }))
);
const UserAdminPage = lazy(() =>
  import('../components/admin/users/UserAdminPage').then((module) => ({
    default: module.UserAdminPage,
  }))
);
const UserPlanAdminPage = lazy(() =>
  import('../components/admin/users/UserPlanAdminPage').then((module) => ({
    default: module.UserPlanAdminPage,
  }))
);
const ReportsAdminPage = lazy(() =>
  import('../components/admin/reports/ReportsAdminPage').then((module) => ({
    default: module.ReportsAdminPage,
  }))
);
const ReportsIndividualCoursesPage = lazy(() =>
  import('../components/admin/reports/ReportsIndividualCoursesAdminPage').then((module) => ({
    default: module.ReportsIndividualCoursesPage,
  }))
);
const ReportsDetailPage = lazy(() =>
  import('../components/admin/reports/ReportsDetailPage').then((module) => ({
    default: module.ReportsDetailPage,
  }))
);
const ReportsCourseAdminPage = lazy(() =>
  import('../components/admin/reports/ReportsCourseAdminPage').then((module) => ({
    default: module.ReportsCourseAdminPage,
  }))
);
const NotFoundPage = lazy(() =>
  import('../components/not-found/NotFoundPage').then((module) => ({
    default: module.NotFoundPage,
  }))
);
const PlandCoursePage = lazy(() =>
  import('../components/admin/plans/PlandCoursePage').then((module) => ({
    default: module.PlandCoursePage,
  }))
);
const PlanCreateEditPage = lazy(() =>
  import('../components/admin/plans/PlanCreateEditPage').then((module) => ({
    default: module.PlanCreateEditPage,
  }))
);
const UserCreateEditPage = lazy(() =>
  import('../components/admin/users/UserCreateEditPage').then((module) => ({
    default: module.UserCreateEditPage,
  }))
);
const IdVerificationPage = lazy(() =>
  import('../components/id-verification/IdVerification').then((module) => ({
    default: module.IdVerificationPage,
  }))
);
const IdQRVerificationPage = lazy(() =>
  import('../components/qrvalidation/QRVerification').then((module) => ({
    default: module.IdQRVerificationPage,
  }))
);
const DirectRegisterQR = lazy(() =>
  import('../components/qrvalidation/QRVerification').then((module) => ({
    default: module.DirectRegisterQR,
  }))
);
const IdCertificationVerificationPage = lazy(() =>
  import('../components/certificationvalidation/CertificationValidation').then((module) => ({
    default: module.IdCertificationVerificationPage,
  }))
);
const UpdateData = lazy(() =>
  import('../components/id-verification/UpdateData').then((module) => ({
    default: module.UpdateData,
  }))
);
const B2BUserPage = lazy(() =>
  import('../components/admin/b2b/B2BUserPage').then((module) => ({
    default: module.B2BUserPage,
  }))
);
const B2BCoursePage = lazy(() =>
  import('../components/admin/b2b/B2BCoursePage').then((module) => ({
    default: module.B2BCoursePage,
  }))
);
const PaymentTypePage = lazy(() =>
  import('../components/register/PaymentTypePage').then((module) => ({
    default: module.PaymentTypePage,
  }))
);
const SelectRegister = lazy(() =>
  import('../components/register/SelectRegister').then((module) => ({
    default: module.SelectRegister,
  }))
);
const DirectRegister = lazy(() =>
  import('../components/register/DirectRegisterPage').then((module) => ({
    default: module.DirectRegister,
  }))
);
const B2BAdminPage = lazy(() =>
  import('../components/admin/b2b/B2BAdminPage').then((module) => ({
    default: module.B2BAdminPage,
  }))
);
const B2BCreateEditPage = lazy(() =>
  import('../components/admin/b2b/B2BCreateEditPage').then((module) => ({
    default: module.B2BCreateEditPage,
  }))
);
const CertificationPage = lazy(() =>
  import('../components/admin/certifications/CertificationPage').then((module) => ({
    default: module.CertificationPage,
  }))
);
const CertificationGenePage = lazy(() =>
  import('../components/admin/certificationsgene/CertificationGenePage').then((module) => ({
    default: module.CertificationGenePage,
  }))
);
const SurveyPage = lazy(() =>
  import('../components/admin/surveys/SurveyPage').then((module) => ({
    default: module.SurveyPage,
  }))
);
const ScoresUsersPage = lazy(() =>
  import('../components/admin/scoresusers/ScoresUsersPage').then((module) => ({
    default: module.ScoresUsersPage,
  }))
);
const LandingPageAdmin = lazy(() =>
  import('../components/admin/landing/LandingPage').then((module) => ({
    default: module.LandingPageAdmin,
  }))
);
const ProfilePageAdmin = lazy(() =>
  import('../components/admin/profile/ProfilePage').then((module) => ({
    default: module.ProfilePageAdmin,
  }))
);
const LandingHomePage = lazy(() =>
  import('../components/landingb2b/LandingHomePage').then((module) => ({
    default: module.LandingHomePage,
  }))
);
const LandingFormPage = lazy(() =>
  import('../components/landingb2b/LandingFormPage').then((module) => ({
    default: module.LandingFormPage,
  }))
);
const LandingThanksPage = lazy(() =>
  import('../components/landingb2b/LandingThanksPage').then((module) => ({
    default: module.LandingThanksPage,
  }))
);
const DashboardAdminPage = lazy(() =>
  import('../components/admin/dashboard/DashboardAdminPage').then((module) => ({
    default: module.DashboardAdminPage,
  }))
);
const DashboardReportsAdminPage = lazy(() =>
  import('../components/admin/dashboard/DashboardReportsAdminPage').then((module) => ({
    default: module.DashboardReportsAdminPage,
  }))
);
const LastSessionAdminPage = lazy(() =>
  import('../components/admin/lastsession/LastSessionAdminPage').then((module) => ({
    default: module.LastSessionAdminPage,
  }))
);
const ListProfilePage = lazy(() =>
  import('../components/admin/createProfile/ListProfilePage').then((module) => ({
    default: module.ListProfilePage,
  }))
);
const DiscountPage = lazy(() =>
  import('../components/admin/discounts/DiscountPage').then((module) => ({
    default: module.DiscountPage,
  }))
);
const ReportsCouponPage = lazy(() =>
  import('../components/admin/reports/ReportsCouponPage').then((module) => ({
    default: module.ReportsCouponPage,
  }))
);
const CertificatesPageAdmin = lazy(() =>
  import('../components/admin/certificates/CertificatesPage').then((module) => ({
    default: module.CertificatesPageAdmin,
  }))
);
const ReportsAdminReviewsPage = lazy(() =>
  import('../components/admin/reports/ReportsAdminReviewsPage').then((module) => ({
    default: module.ReportsAdminReviewsPage,
  }))
);
const ReportsIndividualCoursesReviewsPage = lazy(() =>
  import('../components/admin/reports/ReportsIndividualCoursesReviewsPage').then((module) => ({
    default: module.ReportsIndividualCoursesReviewsPage,
  }))
);
const B2BPlandCoursePage = lazy(() =>
  import('../components/admin/b2b/B2BPlandCoursePage').then((module) => ({
    default: module.B2BPlandCoursePage,
  }))
);
const QRCodesPage = lazy(() =>
  import('../components/admin/QRCodes/QRCodesPage').then((module) => ({
    default: module.QRCodesPage,
  }))
);
const FaqPlacetopayPage = lazy(() =>
  import('../components/faqplacetopay/faqplacetopay').then((module) => ({
    default: module.FaqPlacetopayPage,
  }))
);
const ViewCertification = lazy(() =>
  import('../components/certificationvalidation/ViewCertification').then((module) => ({
    default: module.ViewCertification,
  }))
);
const CenitIncidentePage = lazy(() =>
  import('../components/cenit-incidente-perdida/CenitIncidentePage').then((module) => ({
    default: module.CenitIncidentePage,
  }))
);
const StudyPlansPage = lazy(() =>
  import('../components/admin/studyplans/StudyPlansPage').then((module) => ({
    default: module.StudyPlansPage,
  }))
);
const CertificationSPPage = lazy(() =>
  import('../components/admin/studyplans/CertificationGenePage').then((module) => ({
    default: module.CertificationSPPage,
  }))
);
const UsersCertificatesPage = lazy(() =>
  import('../components/admin/studyplans/UsersCertificatesPage').then((module) => ({
    default: module.UsersCertificatesPage,
  }))
);
const GraduatesVerificationPage = lazy(() =>
  import('../components/graduatesverification/graduatesVerification').then((module) => ({
    default: module.GraduatesVerificationPage,
  }))
);
const GraduatesPlanData = lazy(() =>
  import('../components/graduatesverification/graduatesPlanData').then((module) => ({
    default: module.GraduatesPlanData,
  }))
);
const GraduatesPage = lazy(() =>
  import('../components/admin/graduates/GraduatesPage').then((module) => ({
    default: module.GraduatesPage,
  }))
);
const SucessStoriesPage = lazy(() =>
  import('../components/admin/successstories/SucessStoriesPage').then((module) => ({
    default: module.SucessStoriesPage,
  }))
);
const RecomCoursesPage = lazy(() =>
  import('../components/admin/recomcourses/RecomCoursesPage').then((module) => ({
    default: module.RecomCoursesPage,
  }))
);
const LogswhptpPage = lazy(() =>
  import('../components/admin/logswhptp/LogswhptpPage').then((module) => ({
    default: module.LogswhptpPage,
  }))
);
const MultimediaPageAdmin = lazy(() =>
  import('../components/admin/multimedia/MultimediaPage').then((module) => ({
    default: module.MultimediaPageAdmin,
  }))
);
const PodcastsPageAdmin = lazy(() =>
  import('../components/admin/podcasts/PodcastsPage').then((module) => ({
    default: module.PodcastsPageAdmin,
  }))
);
const PodcastsPage = lazy(() =>
  import('../components/podcasts/PodcastsPage').then((module) => ({
    default: module.PodcastsPage,
  }))
);
const ReportsCourseUsersPage = lazy(() =>
  import('../components/admin/dashboard/ReportsCourseUsersPage').then((module) => ({
    default: module.ReportsCourseUsersPage,
  }))
);
// Archivo con rutas activas en sitio eanx
export const AppRouter = () => {
  const [user, setUser] = useState('');
  const fallback = <div className="text-center py-5">Cargando...</div>;

  return (
    <UserContext.Provider
      value={{
        user,
        setUser,
      }}
    >
      <CartProvider>
        <BrowserRouter>
          <CartModal />
          <Suspense fallback={fallback}>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/*" element={<NotFoundPage />} />
              <Route path="/planes" element={<PlanPage />} />
              <Route path="/perfil" element={<ProfilePage />} />
              <Route path="/registro" element={<SelectRegister />} />
              <Route path="/cursos" element={<CatalogPage />} />
              <Route path="/curso/:courseID" element={<CourseDetailPage />} />
              <Route path="/contactanos" element={<ContactUsPage />} />
              <Route path="/verificar-email" element={<VerifyEmailPage />} />
              <Route path="/tipo-de-pago" element={<PaymentTypePage />} />
              <Route path="/cuenta-creada" element={<AccountCreatedPage />} />
              <Route path="/pago-registrado" element={<RegisteredPurchasePage />} />
              <Route path="/validando-compra" element={<ValidatingPurchasePage />} />
              <Route path="/error-pago" element={<PaymentErrorPage />} />
              <Route path="/ingreso" element={<LoginPage isAdmin={false} />} />
              <Route path="/admin/ingreso" element={<LoginPage isAdmin={true} />} />
              <Route path="/admin" element={<LoginPage isAdmin={true} />} />
              <Route path="/admin/cursosenplanes" element={<PlandCoursePage />} />
              <Route path="/admin/planes" element={<PlanAdminPage />} />
              <Route path="/admin/planes/crear" element={<PlanCreateEditPage />} />
              <Route path="/admin/facturacion" element={<ReportsAdminPage />} />
              <Route path="/admin/facturacioncursos" element={<ReportsIndividualCoursesPage />} />
              <Route path="/admin/facturacion/detalle" element={<ReportsDetailPage />} />
              <Route path="/admin/facturacionreviews" element={<ReportsAdminReviewsPage />} />
              <Route
                path="/admin/facturacioncursosreviews"
                element={<ReportsIndividualCoursesReviewsPage />}
              />
              <Route path="/admin/reportescursos" element={<ReportsCourseAdminPage />} />
              <Route path="/admin/planesdeusuarios" element={<UserPlanAdminPage />} />
              <Route path="/admin/usuarios" element={<UserAdminPage />} />
              <Route path="/admin/usuarios/editar/:id" element={<UserCreateEditPage />} />
              <Route path="/admin/certieanx" element={<CertificationPage />} />
              <Route path="/admin/plantillascertieanx" element={<CertificatesPageAdmin />} />
              <Route path="/admin/certigenerados" element={<CertificationGenePage />} />
              <Route path="/admin/encuestas" element={<SurveyPage />} />
              <Route path="/admin/progresousuarios" element={<ScoresUsersPage />} />
              <Route path="/admin/logsptp" element={<LogswhptpPage />} />
              <Route path="/admin/descuentos" element={<DiscountPage />} />
              <Route path="/admin/reportedescuentos" element={<ReportsCouponPage />} />
              <Route path="/admin/landing" element={<LandingPageAdmin />} />
              <Route path="/admin/multimedia" element={<MultimediaPageAdmin />} />
              <Route path="/admin/podcasts" element={<PodcastsPageAdmin />} />
              <Route path="/admin/profile" element={<ProfilePageAdmin />} />
              <Route path="/admin/b2b" element={<B2BAdminPage />} />
              <Route path="/admin/b2b/crear" element={<B2BCreateEditPage />} />
              <Route path="/admin/b2b/usuarios" element={<B2BUserPage />} />
              <Route path="/admin/b2b/segmentacion" element={<B2BCoursePage />} />
              <Route path="/admin/b2b/courseondemand" element={<B2BPlandCoursePage />} />
              <Route path="/admin/b2b/editar/:id" element={<B2BCreateEditPage />} />
              <Route path="/admin/dashboard" element={<DashboardAdminPage />} />
              <Route path="/admin/dashboardreport" element={<DashboardReportsAdminPage />} />
              <Route path="/admin/dashboardreport/:studyId" element={<ReportsCourseUsersPage />} />
              <Route path="/admin/ultimasesion" element={<LastSessionAdminPage />} />
              <Route path="/admin/perfilbo" element={<ListProfilePage />} />
              <Route path="/admin/planesdeestudios" element={<StudyPlansPage />} />
              <Route path="/admin/estudiantesplanesestudios" element={<CertificationSPPage />} />
              <Route path="/admin/certificarplanesestudios" element={<UsersCertificatesPage />} />
              <Route path="/admin/graduados" element={<GraduatesPage />} />
              <Route path="/admin/casosexito" element={<SucessStoriesPage />} />
              <Route path="/admin/cursosrecomendados" element={<RecomCoursesPage />} />
              <Route path="/recuperar-contrasena" element={<PasswordRecoveryPage />} />
              <Route path="/restablecer-contrasena" element={<ResetPasswordPage />} />
              <Route path="/mensaje-contrasena-enviado" element={<PasswordMessageSentPage />} />
              <Route path="/cambio-contrasena-exitoso" element={<SuccessfulKeyChangePage />} />
              <Route path="/actualizar-datos" element={<IdVerificationPage />} />
              <Route path="/verificar-datos" element={<IdVerificationPage />} />
              <Route path="/graduados" element={<GraduatesVerificationPage />} />
              <Route path="/planesgraduados" element={<GraduatesPlanData />} />
              <Route path="/actualizar" element={<UpdateData />} />
              <Route path="/planes/:slugplan" element={<DirectRegister />} />
              <Route path="/empresas" element={<LandingHomePage />} />
              <Route path="/empresas/contacto" element={<LandingFormPage />} />
              <Route path="/empresas/gracias" element={<LandingThanksPage />} />
              <Route path="/faqplacetopay" element={<FaqPlacetopayPage />} />
              <Route path="/certificate" element={<IdCertificationVerificationPage />} />
              <Route path="/certificate/:code" element={<ViewCertification />} />
              <Route path="/podcasts" element={<PodcastsPage />} />
              <Route path="/qr" element={<IdQRVerificationPage />} />
              <Route path="/qr/:code" element={<DirectRegisterQR />} />
              <Route path="/admin/registrosqr" element={<QRCodesPage />} />
              <Route path="/cenit-incidente-perdida-producto" element={<CenitIncidentePage />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
      </CartProvider>
    </UserContext.Provider>
  );
};
